import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {VnaCampaignService} from '../../services/vna-campaign.service';

@Component({
  selector: 'app-vna-campaign-action-file-preview',
  templateUrl: './vna-campaign-action-file-preview.component.html',
  styleUrls: ['./vna-campaign-action-file-preview.component.scss']
})
export class VnaCampaignActionFilePreviewComponent extends ModalExtended implements OnInit {

    data: any;
    previewData: Object = {};
    enabled: boolean = false;

    constructor(private campHandler: VnaCampaignService) {
        super();
    }

    onExit(){
        this.applyCallback({'reload_actions' : false});
        this.close();
    }

    ngOnInit() {
        this.enabled = true;
        this.campHandler.getActionPreview(this.data['pk']).subscribe(
            (result) => {
                this.previewData = result;
                this.enabled = false;
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/modals/vna-campaign-action-file-preview/vna-campaign-action-file-preview.component.ts